/* eslint-disable */
import {
  getNews,
  getNewsDetail
} from '@/calls/news';

const news = {
  namespaced: true,
  state: {
    requests: 0,
    requestsDetail: 0,
    item: null,
    items: [],
    streams: []
  },
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
    setItems(state, items) {
      state.items = items;
    },
    increaseRequests(state, type) {
      if (type) {
        state[type] += 1;
        return;
      }

      state.requests += 1;
    },
    decreaseRequests(state, type) {
      if (type) {
        state[type] -= 1;
        return;
      }

      state.requests -= 1;
    }
  },
  actions: {
    async get({ commit }) {
      commit('increaseRequests');
      const request = await getNews();

      if (request.success) {
        commit('setItems', request.data);
      }

      commit('decreaseRequests');
    },
    async getDetail({ commit }, slug) {
      commit('increaseRequests', 'requestsDetail');
      const request = await getNewsDetail(slug);

      if (request.success) {
        commit('setItem', request.data);
      }

      commit('decreaseRequests', 'requestsDetail');
    }
  }
};

export default news;
